import DocumentRow from "./DocumentRow";
import "../../styles/table.css";

export default function DocumentTable({ documents = [], onEdit, onDelete }) {
  return (
    <div className="tableCard">
      <table className="modernTable">
        <thead>
          <tr>
            <th>Document</th>
            <th>Document requis</th>
            <th>Fichiers autorisés</th>
            <th>Actions</th>
          </tr>
        </thead>

        <tbody>
          {documents.map((document) => (
            <DocumentRow
              key={document.id}
              document={document}
              onEdit={onEdit}
              onDelete={onDelete}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
}
